module.exports = "<ul>\n<li>Бакалавр выч. техники, <a href=\"https://www.smtu.ru/\">СПбГМТУ</a></li>\n<li>Магистр выч. техники, <a href=\"https://www.smtu.ru/\">СПбГМТУ</a></li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/education_ru.md
// module id = P7j2
// module chunks = 1